/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { ApiService } from './api';

import { Account } from 'src/models/account';
import { AuthResponse } from 'src/models/auth-response.model';

@Injectable({
    providedIn: 'root'
})
export class DataService {
    constructor(private api: ApiService) { }

    async authenticate(emailAddress: string, password: string) {
        return await this.api.postWithoutAuth<AuthResponse>(this.api.endpoints.authenticate + '/token', {emailAddress, password});
    }

    async logout() {
        return await this.api.postWithAuth<boolean>(this.api.endpoints.authenticate + '/revokeToken');
    }

    async refreshUserData() {
        return await this.api.getWithAuth<AuthResponse>(this.api.endpoints.authenticate + '/refreshAuthResponse');
    }

    async updateUserPassword(id, password) {
        return await this.api.putWithAuth<any>(
            this.api.endpoints.users +
            '/updatePassword?id=' +
            id +
            '&password=' +
            encodeURIComponent(password)
            );
    }

    async sendTemporaryPassword(emailAddress: string) {
        return await this.api.postWithoutAuth<Account>(this.api.endpoints.users + '/sendTemporaryPassword?emailAddress=' + emailAddress);
    }

    async validateResetCode(resetCode: string) {
        return await this.api.postWithoutAuth(this.api.endpoints.users + '/validateResetCode?resetCode=' + resetCode);
    }

    setNewPassword(emailAddress: string, resetCode: string, password: string) {
        const url = `${this.api.endpoints.users}/setNewPassword?emailAddress=${emailAddress}&resetCode=${resetCode}&newPassword=${encodeURIComponent(password)}`;
        return this.api.postWithoutAuth<Account | {errorMessage: string}>(url);
    }

    /* Timers ==================== */

    async getTimer(key: string) {
        return await this.api.getWithAuth(this.api.endpoints.timer + '/get?id=' + key);
    }

    async getRecentTimers() {
        return await this.api.getWithAuth(this.api.endpoints.timer + '/getRecentTimers');
    }


    async getStaffPageSettings() {
        return await this.api.getWithAuth(this.api.endpoints.manage + '/getStaffPageSettings');
    }

    async getStaffMembers(organizationId, producerId) {
        return await this.api.getWithAuth(this.api.endpoints.manage + '/getStaffMembers?organizationId=' + organizationId + '&producerId=' + producerId);
    }

    /* Search ==================== */
    async getUserSearch(firstName = '', lastName = '', membershipId = '') {
        let userResults: Account[] = [];

        try {
            const resp: any = await this.api.getWithAuth(`${this.api.endpoints.search}/searchForAccounts?firstName=${firstName}&lastName=${lastName}&membershipId=${membershipId}`);
            userResults = resp ? resp.map(x => Account.create(x)) : [];
        } catch(err) {
            console.error('UserService - getUserSearch', err);
            return [];
        }

        return userResults;
    }

    async getStaffUserSearch(firstName = '', lastName = '', membershipId = '') {
        let userResults: Account[] = [];
        let url = `${this.api.endpoints.search}/staffSearchForAccounts?`;
        if (firstName) {
            url += `firstName=${firstName}`;
        }
        if (lastName) {
            url +=`${firstName ? '&' : ''}lastName=${lastName}`;
        }
        if (membershipId) {
            url += `${firstName || lastName ? '&' : ''}membershipId=${membershipId}`;
        }
        try {
            const resp: any = await this.api.getWithAuth(url);
            userResults = resp ? resp.map(x => Account.create(x)) : [];
        } catch(err) {
            console.error('UserService - getUserSearch', err);
            return [];
        }

        return userResults;
    }

    async getEmailSearch(query: string) {
        return await this.api.getWithAuth(this.api.endpoints.search + '/accountsByEmail?query=' + query);
    }

    async getStaffSearch(query: string) {
        return await this.api.getWithAuth(this.api.endpoints.search + '/staff?query=' + query);
    }

	/* Notifications ==================== */

	async registerUserForNotifications(notificationData: any) {
        const url = `${this.api.endpoints.notifications}?handle=${notificationData}`;
        return await this.api.postWithAuth(url);
	}
}
